export type Falsy = false | 0 | '' | null | undefined;

export default function isTruthy<T>(value: T): value is Exclude<T, Falsy> {
  return Boolean(value);
}
